import { render, staticRenderFns } from "./FestivalItem.vue?vue&type=template&id=b3215e2c&"
import script from "./FestivalItem.vue?vue&type=script&lang=js&"
export * from "./FestivalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3215e2c')) {
      api.createRecord('b3215e2c', component.options)
    } else {
      api.reload('b3215e2c', component.options)
    }
    module.hot.accept("./FestivalItem.vue?vue&type=template&id=b3215e2c&", function () {
      api.rerender('b3215e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/festivals/FestivalItem.vue"
export default component.exports